import { useQuery } from "@apollo/client";
import { OrganizationIntegrationsDocument } from "../../../../__generated__/graphql";

export default function useOrganizationIntegrations() {
  const { data, loading, error } = useQuery(OrganizationIntegrationsDocument);

  return { data, loading, error };
}
